import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Unauthorized.css';

/**
 * Unauthorized Page
 * Shown when user doesn't have CRM access
 */
export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <div className="icon-container">
          <i className="las la-lock" />
        </div>
        <h1>Access Denied</h1>
        <p>You don't have permission to access the CRM system.</p>
        <p className="help-text">
          Please contact your administrator to request CRM access.
        </p>
        <div className="actions">
          <button 
            className="btn-primary"
            onClick={() => navigate('/apps')}
          >
            <i className="las la-th" />
            View Other Apps
          </button>
          <button 
            className="btn-secondary"
            onClick={async () => {
              try {
                // Call Auth Microservice logout API
                const authBackendUrl = process.env.REACT_APP_AUTH_URL || 'http://localhost:4000';
                
                await fetch(`${authBackendUrl}/api/auth/logout`, {
                  method: 'POST',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                });
              } catch (error) {
                console.error('Logout API error:', error);
              }
              
              // Redirect to Auth UI login page
              const authUiUrl = process.env.REACT_APP_AUTH_UI_URL || 'http://localhost:5173';
              window.location.href = `${authUiUrl}/login`;
            }}
          >
            <i className="las la-sign-out-alt" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}


